import { put, call } from 'redux-saga/effects';
import notify from 'devextreme/ui/notify';
import * as actions from '../actions/documents';
import { get, del, post, axiosPut } from '../../utils/api';
import { errorModalOpen } from '../../utils/functions';

export function* getDocumentsNextNumber({ payload }) {
  try {
    const response = yield call(get,
      `/documents/next_number?plant=${payload.plant}`);
    yield put(actions.getDocumentsNextNumberSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getDocumentsNextNumberFail());
  }
}

export function* delDocumentsNextNumber({ payload }) {
  try {
    yield call(del,
      `/documents/next_number?plant=${payload.plant}`);
  } catch (error) {
    yield put(errorModalOpen(error));
  }
}

export function* getActsByDocType({ payload }) {
  try {
    const response = yield call(get,
      `/documents/act?docType=${payload.docType}&plantId=${payload.plant}`);
    yield put(actions.getActsByDocTypeSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getActsByDocTypeFail());
  }
}

export function* getActsByStock({ payload }) {
  try {
    const response = yield call(post, '/documents/act', {
      plantId: Number(payload.plantId),
      filter: payload.filter
    });
    yield put(actions.getActsByStockSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getActsByStockFail());
  }
}

export function* getPiecesByAct({ payload }) {
  try {
    const response = yield call(post, '/documents/piece', {
      docNumId: Number(payload.docNumId),
      filter: payload.filter
    });
    yield put(actions.getPiecesByActSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getPiecesByActFail());
  }
}

export function* getPiecesByStock({ payload }) {
  try {
    const response = yield call(get, `/documents/piece/?docType=${payload.docType}&plantId=${payload.plantId}`);
    yield put(actions.getPiecesByStockSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getPiecesByStockFail());
  }
}

export function* addPieceToAct({ payload }) {
  try {
    yield call(post, '/documents/act/piece_add', {
      items: [payload.pieceNumId],
      docNumId: Number(payload.docNumId)
    });
    yield call(
      notify,
      {
        message: 'СК успешно добавлено',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/documents/piece', {
      docNumId: Number(payload.docNumId),
      filter: payload.filter
    });
    yield put(actions.getPiecesByActSuccess(response));
    yield put(actions.addPieceToActSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.addPieceToActFail());
  }
}

export function* deletePieceFromAct({ payload }) {
  try {
    yield call(post, '/documents/act/piece_delete', {
      docNumId: Number(payload.docNumId),
      items: payload.pieceNumIds
    });
    yield call(
      notify,
      {
        message: 'СК успешно удалено',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/documents/piece', {
      docNumId: Number(payload.docNumId),
      filter: payload.filter
    });
    yield put(actions.getPiecesByActSuccess(response));
    yield put(actions.getActsByStockSuccess(response));
    yield put(actions.deletePieceFromActSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.deletePieceFromActFail());
  }
}

export function* updateAct({ payload }) {
  try {
    yield call(
      axiosPut,
      '/documents/act/update',
      {
        docNumId: payload.docNumId,
        docId: payload.docId,
        docDate: payload.docDate
      }
    );
    yield call(
      notify,
      {
        message: 'Акт успешно обновлен',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/documents/act', {
      plantId: Number(payload.plantId),
      filter: payload.filter
    });
    yield put(actions.getActsByStockSuccess(response));
    yield put(actions.updateActSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.updateActFail());
  }
}

export function* deleteAct({ payload }) {
  try {
    yield call(axiosPut, `/documents/act/delete/${payload.docNumId}`);
    yield call(
      notify,
      {
        message: 'Акт успешно удален',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/documents/act', {
      plantId: Number(payload.plantId),
      filter: payload.filter
    });
    yield put(actions.getActsByStockSuccess(response));
    yield put(actions.deleteActSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.deleteActFail());
  }
}

export function* deleteHolderReport({ payload }) {
  try {
    yield call(axiosPut, `/documents/act/delete/${payload.docNumId}`);
    yield call(
      notify,
      {
        message: 'Отчет успешно удален',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/documents/holder_reports', {
      plantId: Number(payload.plantId),
      ...payload
    });
    yield put(actions.getHolderReportsByStockSuccess(response));
    yield put(actions.deleteHolderReportSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.deleteHolderReportFail());
  }
}

export function* getHolderReportsByStock({ payload }) {
  try {
    const response = yield call(post, '/documents/holder_reports', {
      plantId: Number(payload.plantId),
      ...payload
    });
    yield put(actions.getHolderReportsByStockSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getHolderReportsByStockFail());
  }
}

export function* signActsByClient({ payload }) {
  try {
    yield call(post, '/documents/sign_acts_by_client', payload);
    yield put(actions.signActsByClientSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.signActsByClientFail());
  }
}
